<div 
    *ngIf="showGoBackButton"
    class="d-flex align-items-center justify-content-end" 
    [style]="{ 'margin': margin }"
>
    <div 
        class="go-back d-flex align-items-center gap-2 cursor-pointer fs-5" 
        (click)="goBack()"
    >
        <i class="bi bi-arrow-left text-dark icon"></i>
        <p class="anq-text-primary mb-0">Go back</p>
    </div>
</div>